"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Divider = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement("div", { className: "hr-divider" }, text ? react_1.default.createElement("span", null, text) : ''));
};
exports.default = Divider;
